import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { EditProfileScreen } from '@/modules/professional/screens/EditProfileScreen';
import { AgendaConfigScreen } from '@/modules/professional/screens/AgendaConfigScreen';
import { ComprobantesQueueScreen } from '@/modules/professional/screens/ComprobantesQueueScreen';
import { CalendarioSemanalScreen } from '../screens/CalendarioSemanalScreen';
import { MiConsultorioFaqScreen } from '../screens/MiConsultorioFaqScreen';
import { RevisionCitaScreen } from '../screens/RevisionCitaScreen';
import { MiEquipoScreen } from '@/modules/professional/screens/MiEquipoScreen';
import { EquipoDashboardScreen } from '@/modules/professional/screens/EquipoDashboardScreen';

// Tipos exportados para uso en useNavigate / Link desde pantallas hijas
export type ProfessionalRoute =
  | '/pro/edit'
  | '/pro/AgendaConfig'
  | '/pro/comprobantes'
  | '/pro/CalendarioSemanal'
  | '/pro/MiConsultorioFaq'
  | '/pro/mi-equipo';

export function ProfessionalNavigator() {
  return (
    <Routes>
      <Route path="edit"              element={<EditProfileScreen />} />
      <Route path="AgendaConfig"      element={<AgendaConfigScreen />} />
      <Route path="comprobantes"      element={<ComprobantesQueueScreen />} />
      <Route path="comprobantes/:citaId" element={<RevisionCitaScreen />} />
      <Route path="CalendarioSemanal" element={<CalendarioSemanalScreen />} />
      <Route path="MiConsultorioFaq"  element={<MiConsultorioFaqScreen />} />
      <Route path="mi-equipo"         element={<MiEquipoScreen />} />
      <Route path="equipo/:equipo_uuid" element={<EquipoDashboardScreen />} />
      {/* Ruta por defecto del módulo profesional */}
      <Route index element={<Navigate to="edit" replace />} />
    </Routes>
  );
}
